// (A) 중립 Avatar API — antd 미접촉. (B) PlainAvatar 에 위임(순수 시각).
import type { CSSProperties, ReactNode } from 'react'
import { PlainAvatar } from '../_impl/PlainAvatar'

export interface OmwAvatarProps {
  src?: string
  icon?: ReactNode
  shape?: 'circle' | 'square'
  size?: number | 'small' | 'default' | 'large'
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

export function OmwAvatar(props: OmwAvatarProps) {
  return <PlainAvatar {...props} />
}
